//import { PivotLoggingConfig } from '../config';
import { useSelector, useDispatch } from 'react-redux';

export function PivotLogging(moduleName, consoleLog, notifyPoint){

    const logEveryThing = useSelector(state => state.cbcLogging.logEveryThing);
    const modules = useSelector(state => state.cbcLogging.modules);
    const logPoints = useSelector(state => state.cbcLogging.logPoints);

    if(modules.includes(moduleName) || logEveryThing == true){
        ////console.log(moduleName , ' : ' , consoleLog);
    }

}